/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedPopularSearchesLink_popularSearchesLink = {
    readonly text: string | null;
    readonly path: string | null;
    readonly " $refType": "SharedPopularSearchesLink_popularSearchesLink";
};
export type SharedPopularSearchesLink_popularSearchesLink$data = SharedPopularSearchesLink_popularSearchesLink;
export type SharedPopularSearchesLink_popularSearchesLink$key = {
    readonly " $data"?: SharedPopularSearchesLink_popularSearchesLink$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedPopularSearchesLink_popularSearchesLink">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedPopularSearchesLink_popularSearchesLink",
  "type": "LinkData",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "text",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '2efa0c06bdb8e8b688963baa45fbfe44';
export default node;
